export default __webpack_public_path__ + "static/media/MFL.ee123b5d.png";